<template>
    <div class="context">
        <el-dialog :title="dialogTitle"
                   v-model="dialogVisible"
                   :close-on-click-modal="false"
                   :close-on-press-escape="false"
                   :show-close="false"
                   destroy-on-close
                   center
                   align-center
                   width="450px"
        >
            <div class="login_box">
                <div class="input_box">
                    <el-input v-model="form.name"
                              placeholder="请输入用户名"
                              size="large"
                              autocomplete="off"
                              class="width_all_90 input_item">
                        <template #prefix>
                            <span class="iconfont icon-yonghu-tianchong"></span>
                        </template>
                    </el-input>
                    <el-input v-model="form.password"
                              placeholder="请输入密码"
                              type="password"
                              show-password
                              size="large"
                              @keyup.enter.native="loginNow()"
                              autocomplete="new-password"
                              class="width_all_90 input_item">
                        <template #prefix>
                            <span class="iconfont icon-mima"></span>
                        </template>
                    </el-input>
                </div>
                <div class="bottom_btn">
                    <el-button type="danger"
                               size="large"
                               class="width_100"
                               @click="loginOut"
                    >退出登录</el-button>
                    <el-button class="width_all_90"
                               size="large"
                               @click="loginNow"
                               :disabled="!is_login"
                               type="primary">
                        登 录
                    </el-button>
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import {lcSet, ssSet, ssGet, lcGet, ssRemove, clone} from "@/utils/utils";
    import {mapState, mapMutations, mapActions} from 'vuex'
    import {authShow} from "@/utils/mixins";

    export default {
        name: "lockView",
        mixins: [authShow],
        data() {
            return {
                dialogTitle: '锁定',
                dialogVisible: false,

                form: {
                    name: '',
                    password: ''
                },

                lock_date: 3600,
                inter_lock: null,

                base_date: 3600,

                ctrl_down: false,

                right_btns: [
                    {
                        icon: 'icon-shangchuan',
                        name: '上传影像',
                        route: 'uploadView',
                        decide: ['upload-image']
                    },
                    {
                        icon: 'icon-set-full2',
                        name: '系统管理',
                        route: 'settingView',
                        decide: [
                            'user',
                            'node',
                            'fun',
                        ]
                    }
                ],

                loginLoading: false,

                clientWidth: null,
                clientHeight: null,

                timeout_lock: null,
            }
        },
        computed: {
            ...mapState('homeData', [
                'hos_msg',
                'userData'
            ]),
            is_login() {
                return this.form.name && this.form.password
            },

            windowResize() {
                let {clientWidth, clientHeight} = this;
                return {
                    clientWidth,
                    clientHeight
                }
            }
        },
        watch: {
            windowResize() {
                if(this.clientWidth - this.clientHeight > 0) {
                    console.log('横屏');
                    this.setSreenType('landscape')
                } else {
                    console.log('竖屏');
                    this.setSreenType('vertical')
                }
            }
        },
        mounted() {
            let is_locked = ssGet('is_locked');
            if (is_locked && is_locked.length > 10) {
                this.openLocked()
            } else {
                this.closeLocked()
            }
            this.setWindowListen();
            if(this.hos_msg.not_get) {
                this.getHosData()
            }

            this.clientWidth =  document.documentElement.clientWidth;
            this.clientHeight = document.documentElement.clientHeight;
            window.onresize = () => {
                return (() => {
                    this.clientWidth = document.documentElement.clientWidth;
                    this.clientHeight = document.documentElement.clientHeight;
                })()
            };
            window.addEventListener('storage', this.listenStorage)
        },
        beforeUnmount() {
            clearInterval(this.inter_lock);
            window.removeEventListener('storage', this.listenStorage)
        },
        methods: {
            ...mapMutations('homeData', {
                setUserData: 'setUserData',
                setViewLock: 'setViewLock',
                setHosMsg: 'setHosMsg',
                setSreenType: 'setSreenType',
            }),
            ...mapActions('homeData', {
                getAuthorityData: 'getAuthorityData'
            }),
            getHosData() {
                // this.$http.get('/sysconfig/get').then(res => {
                // this.$http.get('/sysname_and_icon').then(res => {
                //     let data = {
                //         hos_name: res.sysconfig.sys_name,
                //         sys_picture: res.sysconfig.sys_picture,
                //     };
                //     this.setHosMsg(data);
                // })
            },

            setWindowListen() {
                const that = this;
                $(document).on('keyup', e => {
                    if(e.keyCode === 17) {
                        that.ctrl_down = false
                    } else if(that.ctrl_down && e.keyCode === 73) {
                        clearInterval(that.inter_lock);
                        that.openLocked();
                        that.changeLockNow('open')
                    } else if(!that.dialogVisible) {
                        that.lock_date = Number(clone(that.base_date));
                        that.changeLocked()
                    }
                });
                $(document).on('mousemove', e => {
                    if(!that.dialogVisible) {
                        that.lock_date = Number(clone(that.base_date));
                        that.changeLocked()
                    }
                });
                $(document).on('keydown', e => {
                    if(e.keyCode === 17) {
                        that.ctrl_down = true
                    }
                })
            },
            changeLocked() {
                if(this.timeout_lock) {
                    clearTimeout(this.timeout_lock)
                }
                this.timeout_lock = setTimeout(() => {
                    let msg = lcGet('change_lock_date');
                    let lock = msg ? JSON.parse(msg).value : 'true';
                    lock = lock === 'true' ? 'false' : 'true';
                    let item = {
                        type: 'change_lock_date',
                        value: lock
                    };
                    lcSet('change_lock_date', JSON.stringify(item))
                }, 1000)
            },
            changeLockNow(type, is_same) {
                if(type === 'open') {
                    let msg = lcGet('change_lock_open');
                    let lock = msg ? JSON.parse(msg).value : 'true';
                    lock = lock === 'true' ? 'false' : 'true';
                    let item = {
                        type: 'change_lock_open',
                        value: lock
                    };
                    lcSet('change_lock_open', JSON.stringify(item))
                }
                if(type === 'close') {
                    let msg = lcGet('change_lock_close');
                    let lock = msg ? JSON.parse(msg).value : 'true';
                    lock = lock === 'true' ? 'false' : 'true';
                    let item = {
                        type: 'change_lock_close',
                        value: lock,
                        is_same: is_same
                    };
                    lcSet('change_lock_close', JSON.stringify(item))
                }
            },
            listenStorage(e) {
                if(e.newValue.indexOf('{') < 0) return;
                const msg = JSON.parse(e.newValue);
                if(msg.type === 'change_lock_date') {
                    if(!this.dialogVisible) {
                        this.lock_date = Number(clone(this.base_date));
                    }
                }
                if(msg.type === 'change_lock_open') {
                    this.openLocked()
                }
                if(msg.type === 'change_lock_close') {
                    this.closeLocked(msg.is_same)
                }
            },
            loginNow() {
                if(this.loginLoading) return;
                this.loginLoading = true;
                let params = {
                    phone: this.form.name,
                    password: this.form.password
                };
                let user = ssGet('user');
                user = JSON.parse(user);
                // 检测登录的是否为同一账号
                let is_same = 'same';
                if(!user || user.user_name != params.user_name) {
                    is_same = 'not_same'
                }
                this.$http.post('/login', params).then(res => {
                    this.$http.successing('登录成功！');
                    ssSet('user', JSON.stringify(res.data.user));
                    lcSet('token', res.data.token);
                    this.setUserData(JSON.stringify(res.data.user));

                    this.closeLocked(is_same);
                    this.changeLockNow('close', is_same);
                    setTimeout(() => {
                        this.loginLoading = false;
                    }, 500)
                }).catch(err => {
                    this.$http.erroring(err.msg);
                    setTimeout(() => {
                        this.loginLoading = false;
                    }, 500)
                })
            },
            loginOut() {
                this.$http.get('/logout').then(res => {
                    sessionStorage.clear();
                    localStorage.clear();
                    this.$router.push('login');
                    this.$http.successing('登出成功！')
                })
            },

            set_lock_time() {
                this.inter_lock = setInterval(() => {
                    this.lock_date--;
                    if (this.lock_date < 0) {
                        // 倒计时结束，开始锁定

                        clearInterval(this.inter_lock);
                        this.openLocked();
                        this.changeLockNow('open')
                    }
                }, 1000)
            },
            getRandom(min = 0, max = 10) {
                let num = Math.random() * (max - min) + min;
                return num.toFixed(0)
            },

            openLocked() {
                // 锁定状态
                let locked = '';
                for (let i = 0; i < 15; i++) {
                    let n = this.getRandom();
                    locked += n.toString()
                }
                ssSet('is_locked', locked);

                this.dialogVisible = true;
                this.lock_date = 0;
                let user = ssGet('user');
                user = JSON.parse(user);
                this.$nextTick(() => {
                    this.form.name = user ? user.user_name : '';
                    this.setViewLock(true)
                })
            },
            closeLocked(is_same) {
                this.dialogVisible = false;
                this.lock_date = Number(clone(this.base_date));
                let locked = '';
                for (let i = 0; i < 5; i++) {
                    let n = this.getRandom();
                    locked += n.toString()
                }
                ssSet('is_locked', locked);
                this.form = {
                    name: '',
                    password: ''
                };
                this.setViewLock(false);
                clearInterval(this.inter_lock);
                this.set_lock_time();

                if(is_same && is_same === 'not_same') {
                    // 不同账号  刷新
                    // ssRemove('not_first');
                    // this.$router.push('homeView');
                    // setTimeout(() => {window.location.reload()}, 0)
                    let first = 'study-list';
                    this.getAuthorityData().then(res => {
                        ssSet('not_first', 'not_first');
                        if(this.showTab([first])) {
                            // 权限存在studyTable页面
                            this.$router.push('studyTable')
                        } else {
                            for(let i=0;i<this.right_btns.length;i++) {
                                if(this.showTab(this.right_btns[i].decide)) {
                                    this.$router.push(this.right_btns[i].route);
                                    break;
                                }
                            }
                        }
                    });
                }
            },
        }
    }
</script>

<style scoped lang="scss">
    .context {
        .login_box {
            text-align: center;
            .title {
                margin: 15px 0;
            }
            .input_box {
                width: 100%;
                .input_item {
                    margin: 10px 0;
                }
                .el-input__inner {
                    padding: 0 10px;
                }
            }
            .bottom_btn {
                width: 90%;
                margin: 15px auto 30px;
                display: flex;
            }
        }
    }
</style>